let systemConfig = window.systemConfig
export default {
  // 项目任务
  project_task: {
    project: '项目协作',
    projectName: '项目名称',
    projectStatus: '项目状态',
    addProject: '新建项目',
    inputProjectName25: '请输入项目名称，限25个字',
    inputProjectName500: '请输入内容，限500个字',
    projectDescription: '项目描述',
    placeOnFilePro: '归档项目',
    nowProjectStatus: '当前项目状态',
    projectProgress: '项目进度',
    genjuTaskProgress: '根据任务完成进度自动计算',
    handInput: '手动填写',
    visibleRange: '可见范围',
    notPublic: '不公开:只有加入的人员才能看见此项目',
    public: '公开:机构所有人员都能看见此项目',
    notPublic1: '不公开',
    public1: '公开',
    personInCharge: '负责人',
    operationAuth: '操作权限',
    useTaskRoleCustom: '可对任务内的角色权限进行自定义',
    addTask: '新增任务',
    projectCollaboration: '项目协作',
    systemMessage: '系统消息提示',
    projectProMustFill: '项目进度为必填的正整数',
    selectSpecificNumber: '请选择具体时间',
    sureDelProject: '确定要删除该项目吗?',
    role: '角色',
    task: '任务',
    executor: '执行人',
    creater: '创建人',
    setDeadline: '设置截止时间',
    selectDeadlinetime: '请选择截止时间',
    deadlineMustinteger: '截止时间必须是整数',
    sureMovePeopleForPro: '确定要转移项目负责人吗?转移后您将被移出该项目',
    remindSet: '提醒设置',
    deadlineTimeRmind: '在任务截止前，通过以下方式提醒任务执行人',
    taskName: '任务名称',
    state: '状态',
    priority: '优先级',
    selectPriority: '选择优先级',
    tagUseMoveInfo: '该标签在当前项目已被任务所使用，移除后本项目内所有任务将移除该标签',
    startTime: '开始时间',
    deadlineTime: '截止时间',
    endTime: '结束时间',
    createTime: '创建时间',
    lookTheTask: '查看该任务',
    addGroup: '添加分组',
    editGroup: '编辑分组',
    delGroup: '删除分组',
    allProject: '全部项目',
    allTask: '全部任务',
    myResponsible: '我负责的',
    myJoin: '我参与的',
    myCreated: '我创建的',
    haveInHand: '进行中',
    notBegin: '未开始',
    isStop: '已暂停',
    isCompleted: '已完成',
    forInspection: '待检验',
    inspectionReject: '检验驳回',
    stop: '暂停',
    stopPro: '暂停项目',
    enable: '启用',
    enablePro: '启用项目',
    del: '删除',
    delPro: '删除项目',
    projectNowProre: '项目当前进度',
    statusProject1:
      '如果此项目已经结束了，你可以归档它，归档后项目将不允许再次编辑任务，只允许成员查看',
    statusProject2:
      '如果此项目已经不再进行了，你可以暂停它，暂停后项目内任务将不允许再次操作，但还可以重新启动',
    statusProject3: '如果此项目已经暂停或归档了，你可以再次启用它，启用后项目内任务可以再次操作',
    statusProject4: '如果此项目已经不再需要了，你可以删除它，删除后该项目下所有任务同时被删除',
    completedTask: '完成任务',
    overdue: '超期',
    overdueNotStarted: '超期未开始',
    clickChooseTIme: '点击选择时间',
    deadlineDate: '截止日期',
    endDate: '结束日期',
    startDate: '开始日期',
    clickChooseTemplate: '选择模板',
    groupName: '分组名称',
    auth: '权限',
    start: '开 始',
    companyOwnerVisible: '机构所有人员可见',
    projectMemberVisible: '仅项目成员可见',
    projectGroup: '项目分组',
    projectName25: '项目名称不能大于25个字',
    deadTimeMaxStartTime: '截止时间必须大于开始时间',
    newBuildtGroup: '新建分组',
    pleaseSelectDate: '请选择日期',
    pleaseSelectpersoanl: '请选择负责人',
    groupNameRequire: '分组名称必填',
    groupNameNotRepeat: '分组名称不能重复',
    isDeleteGroup: '确定要删除该项目分组吗?',
    projectDesc500: '项目描述必须在500字以内',
    selectTiemMinNowTiem: '所选时间小于当前时间，请确认是否创建?',
    selectTempalte: '选择模版',
    myTempalte: '我的模版',
    allTempalte: '所有模版',
    commonTempalte: '通用模板',
    afterService: '售后服务',
    productDev: '产品研发',
    administrativePersonnel: '行政人事',
    marketingManagement: '市场营销',
    previewProjectTemplate: '预览项目模版',
    useThisTemplate: '使用该模板',
    listView: '列表视图',
    kanbanView: '看板视图',
    calendarView: '日历视图',
    tableView: '表格视图',
    pleaseInputTaskname: '请输入任务名称',
    activationReason: '激活原因',
    isActivateThisTask: '确定要激活此任务吗?',
    isCompleteThisTask: '确定要完成此任务吗?',
    createdSubtaskList: '创建子任务列表',
    subTaskList: '创建子任务列表',
    taskList: '任务列表',
    createdTaskGroup: '创建任务分组',
    taskGroup: '任务分组',
    quoteTemplate: '引用模版',
    addTaskList: '新增任务列表',
    taskListName: '任务列表名称',
    taskGroupName: '任务分组名称',
    usePersonnel: '使用人员',
    preview: '预览',
    workflow: '工作流',
    noTemplateSelect: '暂无模版可选',
    taskGroupNameInfo1: '任务分组名称必需在25字以内，且必填',
    listNameInfo1: '列表名称必需在25字以内，且必填',
    openTaskDetails: '打开任务详情',
    subClass: '下级分类',
    levelClassOrTask: '同级分类或任务',
    rename: '重命名',
    batchOperation: '批量操作',
    markMilestone: '标记里程碑',
    cancelMilestone: '取消里程碑',
    taskStopCannotOperation: '任务暂停，不能进行操作',
    taskCompleteCannotOperation: '任务已经完成,不能进行操作',
    taskTestCannotOperation: '任务待检验,不能进行操作',
    InputBoxCannotEmpty: '输入框不能为空',
    cannotCreateNewTask: '不能新建子任务',
    placeOnFile: '归档',
    projectConnotOperation1: '项目已归档,不能进行其他操作',
    projectConnotOperation2: '项目已暂停,不能进行其他操作',
    taskUnderConnotAddClass: '任务下不能新建分类',
    pleaseFillACtiveReason: '请填写激活原因',
    pleaseFillEditReason: '请填写编辑原因',
    pleaseFillClassName: '请输入分类名称',
    classDontAgaInput: '要删除的分类名称不匹配,请重新输入',
    activeReason: '激活原因',
    editReason: '编辑原因',
    stopReason: '暂停原因',
    haveSubtask: '有子任务尚未完成',
    retract: '收起',
    addPerformer: '收起',
    projectLeader: '项目负责人',
    notActive: '未激活',
    delClass: '删除分类',
    allShare: '所有分享',
    myShare: '我的分享',
    pleaseSelectClass: '请选择分类',
    inputDelClassName: '请输入要删除的分类名称',
    chooseClassMove: '选择需要将此分类移动到的位置',
    chooseClassCopy: '选择需要将此任务复制到的位置',
    tipsTask1: '提示：任务、协作人、子任务将被复制',
    selectExecutor: '请选择执行人',
    settingTaskRemind: '设置任务提醒',
    remindType: '提醒类型',
    customRemind: '自定义提醒',
    deadlineTimeRemind: '截止时间提醒',
    beforeDeadlineTime: '截止前',
    minute: '分钟',
    hour: '小时',
    day: '天',
    hour1: '时',
    minute1: '分',
    second: '秒',
    remindTime: '提醒时间',
    reminder: '被提醒人',
    RemindMode: '提醒方式',
    qixin: systemConfig && systemConfig.qixin ? systemConfig.qixin.zh : '企信',
    customRepeatTask: '自定义重复任务',
    repeat: '重复',
    useDay: '按天',
    useWeek: '按周',
    useMonth: '按月',
    neverRepeat: '不重复',
    frequency: '频率',
    week: '周',
    month: '月',
    clickChoose: '点击选择',
    over: '结束',
    never: '永不',
    cishu: '次数',
    date: '日期',
    happen: '发生',
    tipsTask2: '提示：成员必须绑定企业微信、钉钉或邮箱，才能收到提醒',
    settingRepeatTask: '设置重复任务',
    moveTask: '移动任务',
    copyTask: '复制任务',
    delTask: '删除任务',
    checkOpinion: '校验意见',
    className: '分类名称',
    belongToTask: '属于任务',
    parentTaskName: '父任务名称',
    check: '校验',
    subTask: '子任务',
    subTaskName: '子任务名称',
    addSubTask: '添加子任务',
    quote: '引用',
    byQuote: '被引用',
    onlyParticipantsVisible: '仅参与者可见',
    collaborator: '协作人',
    projectMembers: '项目成员',
    activation: '激活',
    personalTask: '个人任务',
    dianzang: '点赞',
    noDianzang: '暂无点赞',
    editMemberComplete: '修改成员成功',
    sureDelShare: '确定要删除分享吗?',
    shareRequ: '分享内容为必填',
    title100: '标题需在100字以内必填',
    moveTaskComplete: '移动任务成功',
    copyTaskComplete: '复制任务成功',
    delAllsubtaskDel: '删除任务后，所有子任务也会被删除',
    subDealtimeMinParentTime: '子任务截止时间必须小于主任务截止时间',
    sureDelSubtask: '确定删除子任务吗?',
    sureCancelAssociation: '确定取消关联吗?',
    cancelAssociationComplete: '取消关联成功',
    sureActive: '确认要激活吗?',
    sureCompleteTask: '确定完成该任务吗?',
    pleaseFillInCheckReason: '请填写检验编辑原因',
    subtaskName500: '子任务名称不能超过500个字,且为必填',
    pleaseChoosePer: '请选择人员',
    choosePer: '选择人员',
    sureDelCollaborator: '确定删除该协作人吗',
    systemApplication: '系统应用',
    name: '名称',
    addRemindPerson: '添加被提醒人',
    pleaseFillInFrequency: '请填写频率',
    pleaseFillInHappenCishu: '请填写发生次数',
    dataIncomplete: '数据不完整',
    frequencyInteger: '频率必须为正整数',
    happenCishuInteger: '发生次数须为正整数',
    pleaseChooseDate: '请选择日期',
    setTimeLessNow: '设置时间小于当前时间',
    pleaseRemindTime: '请选择提醒时间',
    pleaseDeadTime: '请选择截止前时间',
    pleaseRemindType: '请选择提醒方式',
    pleaseReminder: '请选择被提醒人',
    customFields: '自定义字段',
    currentState: '当前状态',
    checker: '校验人',
    selectPic: '选择图片',
    addTag: '添加标签',
    tag: '标签',
    relation: '关联',
    relationTiggerAddTask: '关联触发新建任务的数据',
    addRelation: '添加关联',
    cancelRelation: '取消关联',
    describe: '描述',
    addMoreFields: '添加更多字段',
    addDescribe: '添加描述',
    enclosure: '附件',
    addEnclosure: '添加附件',
    selectRelation: '选择关联关系',
    firstSelectExecutor: '请优先选择执行人',
    moveMember: '移除成员',
    editProjectAuth: '修改项目权限',
    editProjectRole: '修改项目角色',
    starMarkProject: '星标项目',
    projectShare: '分享',
    projectShareTo: '分享给',
    top: '置顶',
    cancelTop: '取消置顶',
    notAddShare: '您还没有添加分享',
    projectGuideMap: '项目导图',
    timeControl: '时间管控',
    baseSetting: '基本设置',
    projectTag: '项目标签',
    customManage: '自定义管理',
    automationManage: '自动化管理',
    exportProjectTask: '导出项目任务',
    saveProjectTemplate: '保存为项目模板',
    baseInfo: '基本信息',
    statusSet: '状态设置',
    ruleSet: '权限设置',
    taskRemind: '任务提醒',
    taskSet: '任务设置',
    taskActiveInput: '任务重新激活填写激活原因',
    updateDaedlineTimeInput: '更改截止时间填写修改原因',
    Appearance: '外观',
    tagManage: '标签管理',
    projectSet: '项目设置',
    generalTasks: '总任务',
    projectDynamics: '项目动态',
    templateName: '模板名称',
    mamzuContion1: '满足条件的记录自动执行设定的业务流程',
    module: '模块',
    ruleName: '规则名称',
    triggerEvent: '触发事件',
    projectAutomation: '协作自动化',
    sureMoveProjectMember: '确定要移除该项目成员吗?',
    nowProjectUnder: '该项目成员下还存在需要执行的任务,请在下方选择任务交接人，交接后可移除成功',
    handoverPerson: '交接人',
    SelecthandoverPerson: '请选择转交人',
    customWorkbench: '自定义工作台',
    timeWorkbench: '时间工作台',
    sureDelProMember: '确定要删除该项目成员吗?',
    sureDelThisRule: '确定要删除该规则吗?',
    projectTask: '项目任务',
    automatchTrigger1: '在新建记录保存后',
    automatchTrigger2: '在编辑记录保存后',
    automatchTrigger3: '在新建或编辑记录保存后',
    automatchTrigger4: '被完成',
    automatchTrigger5: '被移动',
    automatchTrigger6: '被重新激活',
    automatchTrigger10: '被删除后',
    automatchTrigger7: '在字段自动更新后',
    automatchTrigger8: '在删除记录后',
    automatchTrigger9: '在领取记录后（公海池）',
    automatchTrigger11: '定时触发',
    allChecked: '全选',
    newBuildClass: '新建分类',
    addExecutor: '添加执行人',
    assignTo: '分配给',
    pleaseSelectAssignor: '请选择分配人',
    nameIsNotEmpty: '名称不能为空',
    delList: '删除列表',
    inputDelListName: '请输入要删除的列表名称',
    inputListNameAtypism: '输入的列表名称不一致',
    editFolder: '编辑文件夹',
    delFolder: '删除文件夹',
    notAddFolder: '您还没有添加文件',
    addFolder: '添加文件夹',
    nowAddFolder: '现在就添加',
    folderName: '文件夹名称',
    folderSetting: '文件夹设置',
    addSubFolder: '添加子文件夹',
    addFile: '添加文件',
    sureDelFolder: '确定要删除该文件夹吗?',
    sureDelFile: '确定要删除该文件夹吗?',
    fileName: '文件名称',
    fileType: '文件类型',
    fileSize: '文件大小',
    uploadPeople: '上传人',
    uploadTime: '上传时间',
    shareMemberIsNotEmpty: '分享成员不能为空',
    selectActivityArea: '请选择活动区域',
    workflowDescription: '工作流描述',
    triggerThisWorkflow: '操作以下动作会触发这个工作流',
    whenZhixingRule: '你想在何时执行此规则?',
    condition: '条件',
    conditionTrigger: '条件决定在什么情况下触发规则',
    conditionTriggerNew: '条件决定在什么情况下触发规则; 您必须至少指定一个条件',
    classification: '分类',
    anyCondition: '任何条件',
    matchingCondition: '匹配条件',
    addMatchingCondition: '添加匹配条件',
    selectGroupList: '请选择分组列表',
    executionOperation: '执行操作',
    addOperation: '添加操作',
    autoAssignTo: '自动分配给',
    autoJumpTo: '自动跳转到',
    fieldUpdate: '字段更新',
    fieldZhuanhuan: '字段转换',
    autoFenpei: '自动分配',
    newBuildEmail: '新建邮件',
    newBuildUpdate: '新建与更新',
    noticeRemind: '通知提醒',
    newBuildTask: '新建任务',
    editTask: '编辑任务',
    newBuildUpdateTarget: '新建与更新事件',
    modulesToUpdate: '要更新的模块',
    fieldsToUpdate: '要更新的字段',
    updateToValue: '更新为值',
    constField: '常量字段',
    qutoeField: '引用字段',
    assignor: '被分配人',
    depMemRole: '成员，部门，角色，可多选',
    addMember: '添加成员',
    allocationMechanism: '分配机制',
    polling: '轮询',
    random: '随机',
    insertField: '插入字段',
    haveHandInput: '可手动输入',
    remindUser: '提醒用户',
    remindContent: '提醒内容',
    inputMaxlength1000: '请输入内容,限制1000个字',
    higthContionSetting: '高级条件设置',
    selectClass: '选择分类',
    selectMoudle: '请选择模块',
    inputRuleName: '请填写规则名称',
    RuleNameCunzai: '规则名称已存在',
    selectOnemoudle: '请选择一个模块',
    updateFiledNotEmpty: '要更新的字段不能为空',
    updateTo: '更新为',
    setExecutionOperation: '请设置执行操作',
    operationDelsetIsgoon: '此操作将永久删除该设置, 是否继续?',
    all: '全部',
    taskCustom: '任务自定义',
    projectTaskImport1: '请按照数据模版的格式准备要导入的数据',
    projectTaskImport2: '注意事项：模版中的表头名称不可更改，表头行不能删除',
    projectTaskImport3: '下载数据导入模版',
    projectTaskImport4: '选择需要导入的数据模版',
    projectTaskImport5:
      '数据模版中，表头字段名称需与系统保持一致，单次导入行数不得超过10000行，超出请分批导入',
    selectFile: '选择文件',
    customSort: '自定义排序',
    createTimeAse: '创建时间升序',
    createTimeDese: '创建时间降序',
    editTimeAse: '修改时间升序',
    editTimeDese: '修改时间降序',
    view: '视图',
    todayTask: '今天任务',
    tomorrowTask: '明天任务',
    planTask: '计划任务',
    allMemberSee: '所有成员可见',
    importDataComplete: '导入数据完成',
    setRepeat: '设置重复',
    addCollaborator: '添加协作人',
    delCollaborator: '移除协作人',
    addSubTask1: '新增子任务',
    editSubTask: '编辑子任务',
    delSubTask: '删除子任务',
    onlyCollaboratorShow: '仅协作人可见',
    fieldNameIsnotEmpty: '字段名称不能为空',
    atLeastoneValue: '至少需要存在一个选项值',
    numberRuleIsnotEmpty: '编号规则不能为空',
    formulaIsnotEmpty: '计算公式不能为空',
    errorSelectExcel: '上传有误，请选择Excel格式文件',
    pleaseUploadTemplate: '请上传模版文件',
    pleaseInputReason: '请填写原因',
    secondAfter: '次后',
    projectAuth: '项目权限',
    projectRoleAuth: '项目角色权限',
    projectRoleAuthInfo: '为项目成员在项目中处于不同角色所需的权限设置匹配的项目、任务的操作权限',
    addRoleAuth: '添加角色权限',
    projectRole: '项目角色',
    roleDesc: '角色描述',
    uodateMember: '更新人员',
    updateTiem: '更新时间',
    roleName: '角色名称',
    authSet: '权限配置',
    projectTagManage: '为项目任务通过标签进行有效的管理',
    editTag: '编辑标签',
    addTag1: '新增标签',
    inputTagName: '请输入标签名字',
    selectColor: '选择颜色',
    editClass: '编辑分类',
    addClass: '添加分类',
    taskAuto: '任务自动化',
    sureDelTag: '确定要删除该标签吗?',
    sureDelClass: '确定要删除该分类吗?',
    editRoleAuth: '编辑角色权限',
    roleNameNotEmpty: '角色名称不能为空',
    addRoleSuccess: '新增角色成功',
    sureDelRole: '您确定删除该角色?',
    addSubclassSuccess: '新增子分类成功',
    projectTagNotEmpty: '项目标签名不能为空',
    taskWorkautoInfo: '满足条件的记录自动执行设定的业务流程',
    repeatSetting: '重复设置',
    remind: '提醒',
    taskDeadline: '任务截止前',
    delSetting: '删除设置',
    neverGameover: '永不结束',
    targetTime: '触发时间',
    managementGroup: '管理分组',
    inspection: '检验',
    surveyor: '检验人',
    addChecker: '添加检验人',
    saveAndAdd: '保存并新增',
    taskName500Words: '任务名称为必填，且不能超过500个字',
    taskStartEndTimeInfo: '任务开始时间必须小于截止时间',
    haveFillInNot: '有必填项未填写',
    SaveProjectTemplate: '保存为项目模版',
    wechatWork: '企业微信',
    dingTalk: '钉钉',
    WeChatOfficialAccount: '微信公众号',
    // 20210305
    selectproject: '选择项目',
    tasktag: '任务标签'
  }
}
